import React from 'react';
import { SvgIconProps } from '@mui/material';

export const ProceededCandidatesIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M26.3333 9.82215L22.0668 14.1993L19.6667 11.7372M6.33333 18.0296H17C19.9455 18.0296 22.3333 20.4793 22.3333 23.5012V26.237H1V23.5012C1 20.4793 3.38781 18.0296 6.33333 18.0296ZM17 7.08635C17 10.1082 14.6122 12.558 11.6667 12.558C8.72115 12.558 6.33333 10.1082 6.33333 7.08635C6.33333 4.06447 8.72115 1.61475 11.6667 1.61475C14.6122 1.61475 17 4.06447 17 7.08635Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ProceededCandidatesIcon;
